import React from 'react';
import { Col, Divider, Row, Typography } from 'antd';
import '../../../Styles/ResearchLabs.css';
import scopeImage from '../../../Assets/ResearchLabs/Common/AI Domains/SSTRL-Domain-AI.png';

const { Paragraph, Title } = Typography;

const SstrlScope = () => (
  <section className="scope-section">
    <div className="scope-section-inner">
      <Row gutter={[72, 40]} align="middle" justify="space-between">
        <Col xs={24} md={14}>
          <Title level={2} className="scope-title">Scope</Title>
          <Divider className="ncgsa-divider" />
          <Paragraph className="scope-description">
            The Small Satellite Technology and Research Lab develops national
            capability in CubeSat and small-satellite systems through practical
            education, mission development, and shared research infrastructure.
            Its scope covers the development of CubeSat training platforms,
            collaborative planning and realization of a 3U CubeSat mission, and
            student participation across mission design, integration, testing,
            commissioning, and operations. The lab also enables universities
            across Pakistan to access IST's VHF, UHF, and S-band ground station
            remotely for satellite communication, data acquisition, and
            hands-on experimentation with pico- and nano-satellite missions.
          </Paragraph>
        </Col>
        <Col xs={24} md={9}>
          <div className="scope-image-wrap">
            <img src={scopeImage} alt="Small satellite technology in low Earth orbit" className="scope-image" />
          </div>
        </Col>
      </Row>
    </div>
  </section>
);

export default SstrlScope;
